import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { Card, ButtonGroup, Form } from 'react-bootstrap';
import invertedImg from 'assets/img/generic/inverted.png';
import cardImg from 'assets/img/generic/card.png';
import vibrantImg from 'assets/img/generic/vibrant.png';
import transparentImg from 'assets/img/generic/default.png';
import leftArrowFromLeft from 'assets/img/icons/left-arrow-from-left.svg';
import arrowsH from 'assets/img/icons/arrows-h.svg';
import paragraph from 'assets/img/icons/paragraph.svg';
import sync from 'assets/img/icons/other.svg';
import Flex from 'components/common/Flex';
import AppContext from 'context/Context';
import RadioItem from './RadioItem';
import SoftBadge from 'components/common/SoftBadge';
import IconButton from 'components/common/IconButton';

const Styles = ({ onSubmitData }) => {
 const {
  config: {
   isFluid,
   isRTL,
   isDark,
   navbarPosition,
   navbarStyle,
   showSettingPanel,
   disabledNavbarPosition,
   isNavbarVerticalCollapsed,
   currency,
   showBurgerMenu,
   navbarCollapsed
  },
  setConfig,
  configDispatch
 } = useContext(AppContext);

 const [navbars] = useState([
  {
   name: 'transparent',
   image: transparentImg
  },
  {
   name: 'inverted',
   image: invertedImg
  },
  {
   name: 'card',
   image: cardImg
  },
  {
   name: 'vibrant',
   image: vibrantImg
  }
 ]);

 return (
  <Card className="border-0 scrollbar">
   <Card.Header className="">
    <Card.Title as="div" className="mb-0">
     <h5 className="mb-0">
      <FontAwesomeIcon icon="palette" className="me-2 fs-0" />
      Estilos
     </h5>
    </Card.Title>
   </Card.Header>
   {/* <ScrollBarCustom> */}
   <Card.Body className="pb-0">
    <Flex justifyContent="between">
     <img src={sync} alt="" width={20} className="me-2 h-100" />
     <div className="flex-1">
      <h5 className="fs-0">Restablecer</h5>
      <p className="fs--1 mb-0">Cambia a la configuracion de fabrica </p>
     </div>
     <IconButton
      icon="redo-alt"
      className="m-2 fs--1"
      transform="shrink-2"
      size="sm"
      variant="primary"
      onClick={() => configDispatch({ type: 'RESET' })}
     />
    </Flex>
    <hr />

    <Flex justifyContent="between">
     <img src={leftArrowFromLeft} alt="" width={20} className="me-2 h-100" />
     <div className="flex-1">
      <h5 className="fs-0">Modo RTL</h5>
      <p className="fs--1 mb-0">Cambia la dirección de tu idioma </p>
     </div>
     <Form.Check type="switch" id="rtl-switch" checked={isRTL} onChange={({ target }) => setConfig('isRTL', target.checked)} />
    </Flex>
    <hr />

    <Flex justifyContent="between">
     <img src={arrowsH} alt="" width={20} className="me-2 h-100" />
     <div className="flex-1">
      <h5 className="fs-0">Fluid Layout</h5>
      <p className="fs--1 mb-0">Toggle container layout system</p>
     </div>
     <Form.Check
      type="switch"
      id="fluid-mode-switch"
      checked={isFluid}
      onChange={({ target }) => setConfig('isFluid', target.checked)}
     />
    </Flex>
    <hr />

    <Flex>
     <img src={paragraph} alt="" width={20} className="me-2 h-100" />
     <div>
      <Flex alignItems="center" tag="h5" className="fs-0">
       Navigation Position
       <SoftBadge bg="success" pill className="fs--2 ms-2">
        New
       </SoftBadge>
      </Flex>
      <p className="fs--1 mb-2">Select a suitable navigation system for your web application</p>
      <Form.Select
       className="mb-3"
       size="sm"
       defaultValue={navbarPosition}
       onChange={({ target }) => setConfig('navbarPosition', target.value)}
      >
       {['vertical', 'top', 'combo', 'double-top'].map(option => (
        <option key={option} disabled={disabledNavbarPosition.includes(option)} value={option}>
         {option.charAt(0).toUpperCase() + option.slice(1)}
        </option>
       ))}
      </Form.Select>
     </div>
    </Flex>

    <hr />
    <h5 className="fs-0 d-flex align-items-center">Vertical Navbar Style </h5>
    <p className="fs--1">Switch between styles for your vertical navbar</p>
    <ButtonGroup className="btn-group-navbar-style">
     {navbars.slice(0, 2).map(item => (
      <RadioItem
       key={item.name}
       name="navbar-style"
       label={item.name}
       active={navbarStyle === item.name}
       onChange={() => setConfig('navbarStyle', item.name)}
       image={item.image}
      />
     ))}
    </ButtonGroup>
    <ButtonGroup className="btn-group-navbar-style">
     {navbars.slice(2, 4).map(item => (
      <RadioItem
       key={item.name}
       name="navbar-style"
       label={item.name}
       active={navbarStyle === item.name}
       onChange={() => setConfig('navbarStyle', item.name)}
       image={item.image}
      />
     ))}
    </ButtonGroup>
    <hr />
   </Card.Body>
   <Card.Footer className="pt-0">
    <IconButton
     icon="sync-alt"
     className="m-2 fs--1 float-end"
     //classText="d-none d-sm-block"
     transform="shrink-2"
     size="sm"
     variant="falcon-default"
     onClick={() =>
      onSubmitData({
       styles: {
        isFluid,
        isRTL,
        isDark,
        navbarPosition,
        navbarStyle,
        showSettingPanel,
        disabledNavbarPosition,
        isNavbarVerticalCollapsed,
        currency,
        showBurgerMenu,
        navbarCollapsed
       }
      })
     }
    >
     Establecer
    </IconButton>
   </Card.Footer>
   {/* </ScrollBarCustom> */}
  </Card>
 );
};

Styles.propTypes = { onSubmitData: PropTypes.func.isRequired };

export default Styles;
